































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { StepConditions } from '@/components/analysis/steps/conditions/AnalysisStepConditions';

@Component
export default class PatientAcquisitionPainLevel extends Vue {
  @Prop({ required: true, default: null }) private selectedPainLevel!: number;

  @Provide() painLevels: any = [
    {
      level: '0',
      color: '#2abf8f',
      name: 'no-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '1',
      color: '#5ABF75',
      name: 'mild-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '2',
      color: '#82BE5E',
      name: 'mild-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '3',
      color: '#ADBE48',
      name: 'mild-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '4',
      color: '#D5BD31',
      name: 'moderate-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '5',
      color: '#febd1b',
      name: 'moderate-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '6',
      color: '#FEAB1B',
      name: 'severe-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '7',
      color: '#FE981A',
      name: 'severe-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '8',
      color: '#FF861B',
      name: 'very-severe-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '9',
      color: '#FF731A',
      name: 'very-severe-pain',
      selected: false,
      hovered: false,
    },
    {
      level: '10',
      color: '#ff5e1a',
      name: 'worst-pain-possible',
      selected: false,
      hovered: false,
    },
  ];

  @Watch('selectedPainLevel', { immediate: true, deep: true })
  onSelectedPainLevel() {
    // Deselect all levels
    this.painLevels.map((x: any) => {
      x.selected = false;
    });
    // Select new level if edit mode
    if (this.selectedPainLevel) {
      const painIndex = this.painLevels.findIndex((x: any) => x.level === this.selectedPainLevel);
      if (painIndex >= 0) {
        this.painLevels[painIndex].selected = true;
      }
    }
  }

  selectPain(id: number) {
    const currentSelectedPain = this.painLevels.find((x: any) => x.selected);
    if (currentSelectedPain) currentSelectedPain.selected = false;
    this.painLevels[id].selected = true;
    this.$emit('selectedPainLevel', this.painLevels[id].level);
  }
}
